import React from "react";
import PropTypes from "prop-types";
import { Popup } from "react-map-gl";
import styles from "./tooltip.module.scss";

const MAX_TEXT_LEN = 100;

const truncateText = str => {
    if (str.length < MAX_TEXT_LEN) {
        return str;
    } else {
        return str.slice(0, MAX_TEXT_LEN) + "...";
    }
};

const Tooltip = ({ item, offsetTop, nameSelector, titleSelector }) => {
    if (!item) return null;

    return (
        <Popup
            offsetTop={offsetTop}
            latitude={parseFloat(item.displayLat)}
            longitude={parseFloat(item.displayLong)}
            closeButton={false}
        >
            <div className={styles.tooltip}>
                <h5>{titleSelector(item)}</h5>
                <p>{truncateText(nameSelector(item))}</p>
            </div>
        </Popup>
    );
};
Tooltip.propTypes = {
    item: PropTypes.object,
    offsetTop: PropTypes.number,
    nameSelector: PropTypes.func.isRequired,
    titleSelector: PropTypes.func.isRequired,
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/tooltip/Tooltip.js